import IOffer from './IOffer';

// The country of a new offer until the defaults of the department give another one
export const DEFAULT_COUNTRY = 'Suomi';

const getDefaultOffer = (): IOffer => ({
  address: '',
  attachmentsNote: '',
  buildingType: '',
  cargo: '',
  infoRows: [],
  city: '',
  collateral: '',
  collateralAmount: '',
  collateralPercentage: '',
  contractType: '',
  country: DEFAULT_COUNTRY,
  created: null,
  createdUser: null,
  customer: '',
  customerMark: '',
  customerRole: '',
  customerBranch: '',
  projectPhase: '',
  links: [],
  deliveryTimeNote: '',
  designer: '',
  electronicInvoicingAddress: '',
  electronicInvoicingOperator: '',
  electronicInvoicingOperatorId: '',
  employeeInformationType: '',
  invoiceNote: '',
  invoiceReference: '',
  jobType: '',
  language: '',
  offerText: '',
  deliveryTerms: '',
  offerType: '',
  orderNumber: '',
  organizationUnit: null,
  sentAt: null,
  sentUser: null,
  orderedAt: null,
  orderedUser: null,
  status: '',
  target: '',
  taxRate: '',
  updated: null,
  updatedUser: null,
  validity: '',
  wayOfReceivingType: '',
  worksiteKey: '',
  zipCode: '',
});

export default getDefaultOffer;
